export default "__VITE_ASSET__CQHtFhlJ__"